import { CLEAR_PROGRAM, LOGOUT, SET_PROGRAM } from "../actions/actionTypes";
import { ProgramSession } from "../type";

const initialState: ProgramSession = {
    role: undefined,
    programId: undefined,
    personId: undefined,
    name: undefined,
    description: undefined,
    profileCompleted: undefined
};

export default function programReducer(state: ProgramSession = initialState, action: any) {
    switch (action.type) {
        case SET_PROGRAM:
            return { ...state, ...action.payload };
        case CLEAR_PROGRAM:
        case LOGOUT:
            return { ...initialState };
        default:
            return state;
    }
}
